// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kjrflbE94lpjmK6A1qO0{align-items:center;display:flex}.A1YXNK8lD00uQPSGavKx{width:72px;padding-left:6px;padding-right:6px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `kjrflbE94lpjmK6A1qO0`,
	"wrapVolume": `A1YXNK8lD00uQPSGavKx`
};
export default ___CSS_LOADER_EXPORT___;
